import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import messageService from '../services/messages/MessageService';
import { hasValue } from '../../../services/util/CommonUtil'
import { useTimer } from '../../../hooks/useTimer';
import { TicketType } from '../services/TicketType';
import { UserType } from '../services/messages/UserType';

export const UnreadMessagesContext = React.createContext();
export const useUnreadMessagesContext = () => useContext(UnreadMessagesContext)

export const UnreadMessagesContextProvider = (props) => {

    const { ticketId, clientId } = props

    const [conversationId, setConversationId] = useState(null);
    const [unreadMessagesCount, setUnreadMessagesCount] = useState(null)
    const [unreadMessageIds, setUnreadMessageIds] = useState(null)
    const [markAsRead, setMarkAsRead] = useState(false)

    const updateUnreadMessagesCount = async () => {
        if (conversationId) {
            var msgCount = await messageService.getUnreadMessagesCount(conversationId)
            setUnreadMessagesCount(msgCount);
        }
    }

    const markMessagesAsRead = async () => {
        if (unreadMessageIds && unreadMessageIds.length > 0) {
            messageService.markMessagesRead(unreadMessageIds)
                .then(response => {
                    if (response.status)
                        setUnreadMessagesCount(0)
                })
                .catch(error => console.log(error))
            setMarkAsRead(false)
        }
    }

    const [start, stop, isRunning] = useTimer(updateUnreadMessagesCount, 5 * 60, false)

    useEffect(() => {
        if (hasValue(ticketId) && hasValue(clientId)) {
            setConversationId(null)
            setUnreadMessagesCount(null);
            messageService.getConversation(clientId, UserType.ONLINE_IDENTITY_SERVICE, TicketType.VDO).then(conversationId => {
                setConversationId(conversationId)
            })
        } else if (!ticketId) {
            setConversationId(null)
        }

        return () => stop();
    }, [ticketId])

    useEffect(() => {
        async function initForConversation() {
            if (conversationId && !isRunning) {
                await updateUnreadMessagesCount();
                start();
            } else if (isRunning) {
                stop();
            }
        }
        initForConversation();
    }, [conversationId])

    useEffect(() => {
        if (markAsRead) {
            markMessagesAsRead()
            setMarkAsRead(false)
        }
    }, [markAsRead])
    
    return (
        <UnreadMessagesContext.Provider value={{
            conversationId: conversationId,
            unreadMessagesCount: unreadMessagesCount,
            setUnreadMessagesCount: setUnreadMessagesCount,
            setUnreadMessageIds: setUnreadMessageIds,
            setMarkAsRead: setMarkAsRead
        }} >
            {props.children}
        </UnreadMessagesContext.Provider>
    );
}

UnreadMessagesContextProvider.propTypes = {
    ticketId: PropTypes.number,
    clientId: PropTypes.number
}